import { render, staticRenderFns } from "./MemberProductDetail.vue?vue&type=template&id=37bfeeff&scoped=true&"
import script from "./MemberProductDetail.vue?vue&type=script&lang=js&"
export * from "./MemberProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bfeeff",
  null
  
)

export default component.exports